// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MiW2G","option":"styles_option__2jan2","active":"styles_active__3G0F2"};